import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { theme, useWindowSize, webflowHeaderHeight } from 'global'
import { Box } from 'components'
import { useScroll } from 'react-use-gesture'

const Container = styled(Box)`
  width: 100%;
`

const Sticky = styled(Box)`
  position: static;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${theme.zIndices.foreground};
  background: ${theme.colors.kinkyPurple};
  color: white;
`

interface IProps {
  children: React.ReactNode
  panelHeight: number
  onClick?: (e: React.MouseEvent) => void
}

export const StickyPanel = ({ children, onClick, panelHeight }: IProps) => {
  // Contains the "sticky" header when not fixed, and is used as position calc reference
  // when it is.
  const containerRef = useRef<HTMLDivElement>(null)
  // Element with sticky behaviours applied
  const stickyRef = useRef<HTMLDivElement>(null)

  const { width: wWidth, height: wHeight } = useWindowSize()

  // Apply custom sticky behaviours
  const calc = () => {
    if (containerRef.current && stickyRef.current && wWidth && wHeight) {
      const { y, height } = containerRef.current.getBoundingClientRect()
      const headerHeight = webflowHeaderHeight(wWidth)
      const stickBottom = y >= wHeight - height
      const stickTop = y <= headerHeight
      if (stickBottom || stickTop) {
        stickyRef.current.style.position = 'fixed'
        if (stickTop) {
          stickyRef.current.style.top = `${headerHeight}px`
          stickyRef.current.style.bottom = 'auto'
        } else {
          stickyRef.current.style.bottom = '0'
          stickyRef.current.style.top = 'auto'
        }
      } else {
        stickyRef.current.style.position = 'static'
      }
    }
  }

  const scroll = useScroll(calc, {
    domTarget: window,
  })

  useEffect(scroll, [scroll])
  useEffect(calc)

  return (
    <Container ref={containerRef} height={panelHeight}>
      <Sticky ref={stickyRef} height={panelHeight} onClick={onClick}>
        {children}
      </Sticky>
    </Container>
  )
}
